// src/components/loaders/TopQuestionsSkeleton.jsx
import React from 'react';
import { Box, Paper } from '@mui/material';
import ContentLoader from 'react-content-loader';

const TopQuestionsLoader = ({ count = 5 }) => {
  return (
    <Box className="ai-chatbot-messages-list">
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={`skeleton-${index}`}
          className="message-ai-container"
        >
          <Paper
            elevation={1}
            className="message-ai-bubble"
          >
            <ContentLoader
              speed={2}
              width="100%"
              height={48}              // total height now very compact
              viewBox="0 0 400 48"
              backgroundColor="#f5f5f5"
              foregroundColor="#e8e8e8"
            >
              {/* Single realistic question line – slightly wrapped */}
              <rect x="0"  y="8"   rx="4"  width="360"  height="14" />
              <rect x="0"  y="26"  rx="4"  width="240"  height="14" />  {/* second half if wrapped */}
            </ContentLoader>
          </Paper>
        </Box>
      ))}
    </Box>
  );
};

export default TopQuestionsLoader;